import { MESSAGE_TYPES_AND_SENDERS_URL } from 'api/TemplateIndexAPI';
import { ApiResponse, getRaw } from 'services/api';

export const getMessageTypesAndSenders = (
  projectId: number,
  messageMedium: string,
): Promise<ApiResponse> => {
  return getRaw(
    `${MESSAGE_TYPES_AND_SENDERS_URL}?projectId=${projectId}&messageMedium=${messageMedium}`,
  );
};
